import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import search from './search'
import checkout from './checkout'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        search,
        checkout,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
